{
  "%1$@ are drawing you back: %2$@ s": {
    "en": "%1$@ are drawing you back: %2$@ s",
    "de": "%1$@ holen dich zurück: %2$@ s"
  },
  "%1$@ asks from the %2$@, \"%3$@\"": {
    "en": "%1$@ asks from the %2$@, \"%3$@\"",
    "de": "%1$@ fragt aus dem %2$@, \"%3$@\""
  },
  "%1$@ asks, \"%2$@\"": {
    "en": "%1$@ asks, \"%2$@\"",
    "de": "%1$@ fragt, \"%2$@\""
  },
  "%1$@ bought for %2$@c.": {
    "en": "%1$@ bought for %2$@c.",
    "de": "%1$@ für %2$@c gekauft."
  },
  "%1$@ damage, %2$@ balance a swing": {
    "en": "%1$@ damage, %2$@ balance a swing",
    "de": "%1$@ Schaden, %2$@ Gleichgewicht je Schlag"
  },
  "%1$@ exclaims from the %2$@, \"%3$@\"": {
    "en": "%1$@ exclaims from the %2$@, \"%3$@\"",
    "de": "%1$@ ruft aus dem %2$@, \"%3$@\""
  },
  "%1$@ exclaims, \"%2$@\"": {
    "en": "%1$@ exclaims, \"%2$@\"",
    "de": "%1$@ ruft, \"%2$@\""
  },
  "%1$@ is drawing you back: %2$@ s": {
    "en": "%1$@ is drawing you back: %2$@ s",
    "de": "%1$@ holt dich zurück: %2$@ s"
  },
  "%1$@ of %2$@": {
    "en": "%1$@ of %2$@",
    "de": "%1$@ von %2$@"
  },
  "%1$@ of %2$@ practice toward rank %3$@": {
    "en": "%1$@ of %2$@ practice toward rank %3$@",
    "de": "%1$@ von %2$@ Übung bis Rang %3$@"
  },
  "%1$@ says from the %2$@, \"%3$@\"": {
    "en": "%1$@ says from the %2$@, \"%3$@\"",
    "de": "%1$@ sagt aus dem %2$@, \"%3$@\""
  },
  "%1$@ says, \"%2$@\"": {
    "en": "%1$@ says, \"%2$@\"",
    "de": "%1$@ sagt, \"%2$@\""
  },
  "%1$@ sold for %2$@c.": {
    "en": "%1$@ sold for %2$@c.",
    "de": "%1$@ für %2$@c verkauft."
  },
  "%1$@ sold for %2$@c. Your hands are empty.": {
    "en": "%1$@ sold for %2$@c. Your hands are empty.",
    "de": "%1$@ für %2$@c verkauft. Deine Hände sind leer."
  },
  "%1$@ takes on those who pass a trial. Passing it commits you to nothing: you choose afterwards whether to become a %2$@.": {
    "en": "%1$@ takes on those who pass a trial. Passing it commits you to nothing: you choose afterwards whether to become a %2$@.",
    "de": "%1$@ nimmt auf, wer eine Prüfung besteht. Sie verpflichtet dich zu nichts: Du entscheidest danach, ob du %2$@ wirst."
  },
  "%1$@ whispers from the %2$@, \"%3$@\"": {
    "en": "%1$@ whispers from the %2$@, \"%3$@\"",
    "de": "%1$@ flüstert aus dem %2$@, \"%3$@\""
  },
  "%1$@ whispers, \"%2$@\"": {
    "en": "%1$@ whispers, \"%2$@\"",
    "de": "%1$@ flüstert, \"%2$@\""
  },
  "%1$@ yells from the %2$@, \"%3$@\"": {
    "en": "%1$@ yells from the %2$@, \"%3$@\"",
    "de": "%1$@ schreit aus dem %2$@, \"%3$@\""
  },
  "%1$@ yells, \"%2$@\"": {
    "en": "%1$@ yells, \"%2$@\"",
    "de": "%1$@ schreit, \"%2$@\""
  },
  "%@ deals in weapons. He buys back what he sells for half its price.": {
    "en": "%@ deals in weapons. He buys back what he sells for half its price.",
    "de": "%@ handelt mit Waffen. Was er verkauft, kauft er zum halben Preis zurück."
  },
  "%@ draw you back into the dream.": {
    "en": "%@ draw you back into the dream.",
    "de": "%@ holen dich in den Traum zurück."
  },
  "%@ draws you back into the dream.": {
    "en": "%@ draws you back into the dream.",
    "de": "%@ holt dich in den Traum zurück."
  },
  "%@ entered the game.": {
    "en": "%@ entered the game.",
    "de": "%@ hat das Spiel betreten."
  },
  "%@ is not a command. Write /w to whisper or /y to yell.": {
    "en": "%@ is not a command. Write /w to whisper or /y to yell.",
    "de": "%@ ist kein Befehl. Schreib /w zum Flüstern oder /y zum Schreien."
  },
  "%@ left the game.": {
    "en": "%@ left the game.",
    "de": "%@ hat das Spiel verlassen."
  },
  "%@ lose hold of you.": {
    "en": "%@ lose hold of you.",
    "de": "%@ verlieren den Halt an dir."
  },
  "%@ loses hold of you.": {
    "en": "%@ loses hold of you.",
    "de": "%@ verliert den Halt an dir."
  },
  "%@ teaches its first rank for a task.": {
    "en": "%@ teaches its first rank for a task.",
    "de": "%@ lehrt den ersten Rang für eine Aufgabe."
  },
  "%@c": {
    "en": "%@c",
    "de": "%@c"
  },
  "*: repeat": {
    "en": "*: repeat",
    "de": "*: wiederholen"
  },
  "3D characters and props by KayKit.": {
    "en": "3D characters and props by KayKit.",
    "de": "3D-Charaktere und -Objekte von KayKit."
  },
  "A newer version is available. Please update your client to keep playing.": {
    "en": "A newer version is available. Please update your client to keep playing.",
    "de": "Eine neuere Version ist verfügbar. Bitte aktualisiere deinen Client, um weiterzuspielen."
  },
  "About Somnio": {
    "en": "About Somnio",
    "de": "Über Somnio"
  },
  "Already logged in.": {
    "en": "Already logged in.",
    "de": "Du bist bereits angemeldet."
  },
  "Anyone up for the North Wood?": {
    "en": "Anyone up for the North Wood?",
    "de": "Kommt jemand mit in den Nordwald?"
  },
  "Ask for the trial": {
    "en": "Ask for the trial",
    "de": "Um die Prüfung bitten"
  },
  "Bad credentials.": {
    "en": "Bad credentials.",
    "de": "Falsche Zugangsdaten."
  },
  "Balance": {
    "en": "Balance",
    "de": "Gleichgewicht"
  },
  "Become a %@": {
    "en": "Become a %@",
    "de": "%@ werden"
  },
  "Become a %@?": {
    "en": "Become a %@?",
    "de": "%@ werden?"
  },
  "Broadcast message: %@": {
    "en": "Broadcast message: %@",
    "de": "Broadcast Nachricht: %@"
  },
  "Buy for %@c": {
    "en": "Buy for %@c",
    "de": "Für %@c kaufen"
  },
  "Cancel": {
    "en": "Cancel",
    "de": "Abbrechen"
  },
  "Chat": {
    "en": "Chat",
    "de": "Chat"
  },
  "Close": {
    "en": "Close",
    "de": "Schließen"
  },
  "Copyright": {
    "en": "© Copyright 2026 Tobias Hagemann",
    "de": "© Copyright 2026 Tobias Hagemann"
  },
  "Could not log out other browsers. Try again.": {
    "en": "Could not log out other browsers. Try again.",
    "de": "Andere Browser konnten nicht abgemeldet werden. Versuche es erneut."
  },
  "Drive off %@ nightmares.": {
    "en": "Drive off %@ nightmares.",
    "de": "Vertreibe %@ Albträume."
  },
  "Drive off a nightmare.": {
    "en": "Drive off a nightmare.",
    "de": "Vertreibe einen Albtraum."
  },
  "Each rank adds to every hit you land.": {
    "en": "Each rank adds to every hit you land.",
    "de": "Jeder Rang verstärkt jeden Treffer, den du landest."
  },
  "Each rank brings your balance back faster.": {
    "en": "Each rank brings your balance back faster.",
    "de": "Mit jedem Rang kehrt dein Gleichgewicht schneller zurück."
  },
  "Each rank makes nightmares miss you more often.": {
    "en": "Each rank makes nightmares miss you more often.",
    "de": "Mit jedem Rang verfehlen Albträume dich öfter."
  },
  "Each rank mends more with every touch.": {
    "en": "Each rank mends more with every touch.",
    "de": "Jeder Rang heilt mit jeder Berührung mehr."
  },
  "Each rank raises your health by %@.": {
    "en": "Each rank raises your health by %@.",
    "de": "Jeder Rang erhöht deine Gestalt um %@."
  },
  "Each rank raises your spirit by %@.": {
    "en": "Each rank raises your spirit by %@.",
    "de": "Jeder Rang erhöht deinen Geist um %@."
  },
  "Each rank shortens the pause between your swings.": {
    "en": "Each rank shortens the pause between your swings.",
    "de": "Jeder Rang verkürzt die Pause zwischen deinen Schlägen."
  },
  "Earned by a task": {
    "en": "Earned by a task",
    "de": "Durch eine Aufgabe verdient"
  },
  "Email:": {
    "en": "Email:",
    "de": "E-Mail:"
  },
  "Error %@ occurred.": {
    "en": "Error %@ occurred.",
    "de": "Der Fehler %@ ist aufgetreten!"
  },
  "Every other browser that remembers your password will have to log in again.": {
    "en": "Every other browser that remembers your password will have to log in again.",
    "de": "Jeder andere Browser, der sich dein Passwort merkt, muss sich erneut anmelden."
  },
  "Falling starts the count over.": {
    "en": "Falling starts the count over.",
    "de": "Fällst du, beginnt die Zählung von vorn."
  },
  "Finish your current task first.": {
    "en": "Finish your current task first.",
    "de": "Erfülle zuerst deine jetzige Aufgabe."
  },
  "For sale": {
    "en": "For sale",
    "de": "Im Angebot"
  },
  "Fullscreen": {
    "en": "Fullscreen",
    "de": "Vollbild"
  },
  "Ghost model by Quaternius.": {
    "en": "Ghost model by Quaternius.",
    "de": "Geist-Modell von Quaternius."
  },
  "Give up": {
    "en": "Give up",
    "de": "Aufgeben"
  },
  "Give up that trial": {
    "en": "Give up that trial",
    "de": "Diese Prüfung aufgeben"
  },
  "Give up the task": {
    "en": "Give up the task",
    "de": "Aufgabe aufgeben"
  },
  "Give up the trial": {
    "en": "Give up the trial",
    "de": "Prüfung aufgeben"
  },
  "Health": {
    "en": "Health",
    "de": "Gestalt"
  },
  "Holding the Moonstone, click a dreamer to tend them. Your spirit mends them while you stay close.": {
    "en": "Holding the Moonstone, click a dreamer to tend them. Your spirit mends them while you stay close.",
    "de": "Klick mit dem Mondstein in der Hand einen Träumer an, um dich seiner anzunehmen. Dein Geist heilt ihn, solange du bei ihm bleibst."
  },
  "Holding the Moonstone, stay close to a fallen dreamer you tend to raise them.": {
    "en": "Holding the Moonstone, stay close to a fallen dreamer you tend to raise them.",
    "de": "Bleib mit dem Mondstein in der Hand bei einem gefallenen Träumer, dessen du dich annimmst, um ihn zurückzuholen."
  },
  "If you don't have an account, click here!": {
    "en": "If you don't have an account, click here!",
    "de": "Wenn du keinen Account hast, klick hier!"
  },
  "In hand": {
    "en": "In hand",
    "de": "In der Hand"
  },
  "Items": {
    "en": "Items",
    "de": "Gegenstände"
  },
  "Items: %@": {
    "en": "Items: %@",
    "de": "Items: %@"
  },
  "Learn %@": {
    "en": "Learn %@",
    "de": "%@ lernen"
  },
  "Leave Game": {
    "en": "Leave Game",
    "de": "Spiel verlassen"
  },
  "Loading the world...": {
    "en": "Loading the world...",
    "de": "Welt wird geladen..."
  },
  "Log In": {
    "en": "Log In",
    "de": "Anmelden"
  },
  "Log Out Other Browsers": {
    "en": "Log Out Other Browsers",
    "de": "Andere Browser abmelden"
  },
  "Log Them Out": {
    "en": "Log Them Out",
    "de": "Abmelden"
  },
  "Logged out %@ other browsers.": {
    "en": "Logged out %@ other browsers.",
    "de": "%@ andere Browser abgemeldet."
  },
  "Logged out one other browser.": {
    "en": "Logged out one other browser.",
    "de": "Einen anderen Browser abgemeldet."
  },
  "Master of the Fighters": {
    "en": "Master of the Fighters",
    "de": "Meister der Kämpfer"
  },
  "Master of the Healers": {
    "en": "Master of the Healers",
    "de": "Meisterin der Heiler"
  },
  "Mastered": {
    "en": "Mastered",
    "de": "Gemeistert"
  },
  "Meet me at the inn.": {
    "en": "Meet me at the inn.",
    "de": "Wir treffen uns im Gasthaus."
  },
  "Mend %@ health on other dreamers.": {
    "en": "Mend %@ health on other dreamers.",
    "de": "Heile %@ Gestalt bei anderen Träumern."
  },
  "Needs %1$@ at rank %2$@": {
    "en": "Needs %1$@ at rank %2$@",
    "de": "Braucht %1$@ auf Rang %2$@"
  },
  "Nickname": {
    "en": "Nickname",
    "de": "Nickname"
  },
  "Nickname already exists.": {
    "en": "Nickname already exists.",
    "de": "Der Nickname ist bereits vergeben."
  },
  "Nickname:": {
    "en": "Nickname:",
    "de": "Nickname:"
  },
  "No other browser remembers your password.": {
    "en": "No other browser remembers your password.",
    "de": "Kein anderer Browser merkt sich dein Passwort."
  },
  "No role yet": {
    "en": "No role yet",
    "de": "Noch keine Rolle"
  },
  "Not yet": {
    "en": "Not yet",
    "de": "Noch nicht"
  },
  "OK": {
    "en": "OK",
    "de": "OK"
  },
  "Options": {
    "en": "Options",
    "de": "Optionen"
  },
  "Password": {
    "en": "Password",
    "de": "Passwort"
  },
  "Password (*):": {
    "en": "Password (*):",
    "de": "Passwort (*):"
  },
  "Password:": {
    "en": "Password:",
    "de": "Passwort:"
  },
  "People:": {
    "en": "People:",
    "de": "Volk:"
  },
  "Players": {
    "en": "Players",
    "de": "Spieler"
  },
  "Players: %@": {
    "en": "Players: %@",
    "de": "Spieler: %@"
  },
  "Rank %1$@ of %2$@": {
    "en": "Rank %1$@ of %2$@",
    "de": "Rang %1$@ von %2$@"
  },
  "Reconnecting...": {
    "en": "Reconnecting...",
    "de": "Verbindung wird wiederhergestellt..."
  },
  "Registration failed.": {
    "en": "Registration failed.",
    "de": "Registrierung fehlgeschlagen."
  },
  "Remember password": {
    "en": "Remember password",
    "de": "Passwort merken"
  },
  "Resume": {
    "en": "Resume",
    "de": "Fortsetzen"
  },
  "Sell": {
    "en": "Sell",
    "de": "Verkaufen"
  },
  "Sell for %@c": {
    "en": "Sell for %@c",
    "de": "Für %@c verkaufen"
  },
  "Shopkeeper": {
    "en": "Shopkeeper",
    "de": "Krämer"
  },
  "Sign Up": {
    "en": "Sign Up",
    "de": "Registrieren"
  },
  "Somnio": {
    "en": "Somnio",
    "de": "Somnio"
  },
  "Somnio needs WebGL. Try a current version of Safari, Chrome, or Firefox on a desktop computer.": {
    "en": "Somnio needs WebGL. Try a current version of Safari, Chrome, or Firefox on a desktop computer.",
    "de": "Somnio benötigt WebGL. Probiere eine aktuelle Version von Safari, Chrome oder Firefox auf einem Desktop-Rechner."
  },
  "Somnio needs a desktop computer.": {
    "en": "Somnio needs a desktop computer.",
    "de": "Somnio benötigt einen Desktop-Rechner."
  },
  "Spirit": {
    "en": "Spirit",
    "de": "Geist"
  },
  "Stay": {
    "en": "Stay",
    "de": "Bleiben"
  },
  "Study this": {
    "en": "Study this",
    "de": "Das lernen"
  },
  "Studying %1$@: %2$@ of %3$@": {
    "en": "Studying %1$@: %2$@ of %3$@",
    "de": "Du lernst %1$@: %2$@ von %3$@"
  },
  "Studying nothing": {
    "en": "Studying nothing",
    "de": "Du lernst nichts"
  },
  "Take the task": {
    "en": "Take the task",
    "de": "Aufgabe annehmen"
  },
  "Talk here. /w to whisper, /y to yell": {
    "en": "Talk here. /w to whisper, /y to yell",
    "de": "Hier reden. /w zum Flüstern, /y zum Schreien"
  },
  "Task: %@": {
    "en": "Task: %@",
    "de": "Aufgabe: %@"
  },
  "Thanks paragraph": {
    "en": "Somnio was my first passion project, developed from 2003 to 2006. This is its revival.",
    "de": "Somnio war mein erstes Herzensprojekt, entwickelt von 2003 bis 2006. Dies ist seine Neuauflage."
  },
  "That name uses characters Somnio does not allow.": {
    "en": "That name uses characters Somnio does not allow.",
    "de": "Dieser Name verwendet Zeichen, die Somnio nicht erlaubt."
  },
  "The connection was lost.": {
    "en": "The connection was lost.",
    "de": "Die Verbindung wurde unterbrochen!"
  },
  "The game is played with a keyboard and a mouse. Come back from a laptop or desktop.": {
    "en": "The game is played with a keyboard and a mouse. Come back from a laptop or desktop.",
    "de": "Das Spiel wird mit Tastatur und Maus gespielt. Komm von einem Laptop oder Desktop-Rechner zurück."
  },
  "The server is being updated. Please try again in a few moments.": {
    "en": "The server is being updated. Please try again in a few moments.",
    "de": "Der Server wird gerade aktualisiert. Bitte versuche es in wenigen Augenblicken erneut."
  },
  "The server is currently not reachable. Try again later.": {
    "en": "The server is currently not reachable. Try again later.",
    "de": "Der Server ist zurzeit nicht erreichbar! Versuch es ein anderes Mal!"
  },
  "This browser cannot render 3D graphics.": {
    "en": "This browser cannot render 3D graphics.",
    "de": "Dieser Browser kann keine 3D-Grafik darstellen."
  },
  "Too many attempts. Wait a little before trying again.": {
    "en": "Too many attempts. Wait a little before trying again.",
    "de": "Zu viele Versuche. Bitte warte einen Moment und versuche es dann erneut."
  },
  "Try Again": {
    "en": "Try Again",
    "de": "Erneut versuchen"
  },
  "UI borders by Kenney.": {
    "en": "UI borders by Kenney.",
    "de": "UI-Rahmen von Kenney."
  },
  "Update required": {
    "en": "Update required",
    "de": "Update erforderlich"
  },
  "Version: %@": {
    "en": "Version: %@",
    "de": "Version: %@"
  },
  "Wake there": {
    "en": "Wake there",
    "de": "Dort aufwachen"
  },
  "Walk to the %@ and come back.": {
    "en": "Walk to the %@ and come back.",
    "de": "Geh bis in den %@ und kehre zurück."
  },
  "Watch out, nightmares about!": {
    "en": "Watch out, nightmares about!",
    "de": "Vorsicht, hier spuken Albträume!"
  },
  "Welcome to Somnio!": {
    "en": "Welcome to Somnio!",
    "de": "Willkommen zu Somnio!"
  },
  "You are a %1$@. %2$@ has nothing to teach you.": {
    "en": "You are a %1$@. %2$@ has nothing to teach you.",
    "de": "Du bist %1$@. %2$@ kann dich nichts lehren."
  },
  "You are now a %@.": {
    "en": "You are now a %@.",
    "de": "Du bist jetzt %@."
  },
  "You are studying": {
    "en": "You are studying",
    "de": "Das lernst du"
  },
  "You can study": {
    "en": "You can study",
    "de": "Das kannst du lernen"
  },
  "You cannot move, but you can still speak. A Healer can draw you back.": {
    "en": "You cannot move, but you can still speak. A Healer can draw you back.",
    "de": "Du kannst dich nicht bewegen, aber noch sprechen. Ein Heiler kann dich zurückholen."
  },
  "You cannot strike while you hold this trial.": {
    "en": "You cannot strike while you hold this trial.",
    "de": "Solange du diese Prüfung trägst, kannst du nicht zuschlagen."
  },
  "You carry nothing %@ buys.": {
    "en": "You carry nothing %@ buys.",
    "de": "Du trägst nichts, was %@ kauft."
  },
  "You did what %@ asked.": {
    "en": "You did what %@ asked.",
    "de": "Du hast getan, was %@ verlangt hat."
  },
  "You draw %@ back into the dream.": {
    "en": "You draw %@ back into the dream.",
    "de": "Du holst %@ in den Traum zurück."
  },
  "You have fallen": {
    "en": "You have fallen",
    "de": "Du bist gefallen"
  },
  "You hold another master's trial. One trial at a time.": {
    "en": "You hold another master's trial. One trial at a time.",
    "de": "Du stehst in der Prüfung eines anderen Meisters. Immer nur eine Prüfung."
  },
  "You let go and wake, weakened.": {
    "en": "You let go and wake, weakened.",
    "de": "Du lässt los und wachst geschwächt auf."
  },
  "You lose hold of %@.": {
    "en": "You lose hold of %@.",
    "de": "Du verlierst den Halt an %@."
  },
  "You need %@c more.": {
    "en": "You need %@c more.",
    "de": "Dir fehlen %@c."
  },
  "You own %@c.": {
    "en": "You own %@c.",
    "de": "Du besitzt %@c."
  },
  "You passed the trial. Accepting makes you a %@ for good. It cannot be undone, and the other master will not teach you afterwards.": {
    "en": "You passed the trial. Accepting makes you a %@ for good. It cannot be undone, and the other master will not teach you afterwards.",
    "de": "Du hast die Prüfung bestanden. Nimmst du an, bist du für immer %@. Das lässt sich nicht rückgängig machen, und der andere Meister lehrt dich danach nicht mehr."
  },
  "You receive %@c.": {
    "en": "You receive %@c.",
    "de": "Du erhältst %@c."
  },
  "You study nothing. Choose a teaching below.": {
    "en": "You study nothing. Choose a teaching below.",
    "de": "Du lernst nichts. Wähle unten eine Lehre."
  },
  "You study one teaching at a time. What you do out there fills its practice, and full practice is its next rank.": {
    "en": "You study one teaching at a time. What you do out there fills its practice, and full practice is its next rank.",
    "de": "Du lernst immer nur eine Lehre. Was du draußen tust, füllt ihre Übung, und volle Übung ist ihr nächster Rang."
  },
  "You will wake at the inn, weakened.": {
    "en": "You will wake at the inn, weakened.",
    "de": "Du wachst geschwächt im Gasthaus auf."
  },
  "Your %1$@ deepens: rank %2$@.": {
    "en": "Your %1$@ deepens: rank %2$@.",
    "de": "Deine Lehre %1$@ vertieft sich: Rang %2$@."
  },
  "Your health gives out. You fall.": {
    "en": "Your health gives out. You fall.",
    "de": "Deine Gestalt gibt nach. Du fällst."
  },
  "Your password could not be saved.": {
    "en": "Your password could not be saved.",
    "de": "Dein Passwort konnte nicht gespeichert werden."
  },
  "Your purse": {
    "en": "Your purse",
    "de": "Dein Geldbeutel"
  },
  "Your session expired. Please log in again.": {
    "en": "Your session expired. Please log in again.",
    "de": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an."
  },
  "Your task is done. Return to your master.": {
    "en": "Your task is done. Return to your master.",
    "de": "Deine Aufgabe ist erfüllt. Kehre zu deinem Meister zurück."
  },
  "Your trial": {
    "en": "Your trial",
    "de": "Deine Prüfung"
  },
  "east": {
    "en": "east",
    "de": "Osten"
  },
  "miss": {
    "en": "miss",
    "de": "daneben"
  },
  "north": {
    "en": "north",
    "de": "Norden"
  },
  "north-east": {
    "en": "north-east",
    "de": "Nordosten"
  },
  "north-west": {
    "en": "north-west",
    "de": "Nordwesten"
  },
  "south": {
    "en": "south",
    "de": "Süden"
  },
  "south-east": {
    "en": "south-east",
    "de": "Südosten"
  },
  "south-west": {
    "en": "south-west",
    "de": "Südwesten"
  },
  "west": {
    "en": "west",
    "de": "Westen"
  },
  "winded": {
    "en": "winded",
    "de": "außer Atem"
  }
}
